import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";

export default class PageCommon {
  constructor() {
    jQuery(".info").on("click", this.showInfo.bind(this));
    jQuery(".js-close").on("click", this.closeInfo.bind(this));

    this.initTurn();

  }

  initTurn() {
    if (Pqp.isMobile()) {
      jQuery(window).on("resize.info", jQuery.proxy(this.onCheckPortrait, this));
      this.onCheckPortrait();
    }
  }

  onCheckPortrait() {
    if (Pqp.isMobile()) {
      var w = jQuery(window).outerWidth();
      var h = jQuery(window).outerHeight();
      if (h <= w) {
        jQuery(".mcTurn").show();
      } else {
        jQuery(".mcTurn").hide();
      }
    }
  }


  init(metaInfo) {
    //Pqp.trace("PageCommon");
    this.metaInfo = metaInfo;
    //
    if (this.metaInfo) {
      history.replaceState(history.state, metaInfo.Title, metaInfo.Url + location.hash);
      document.title = metaInfo.Title;
    }
  }

  showInfo() {
    jQuery(".js-progetto").show();

  }
 closeInfo() {
   jQuery(".js-progetto").hide();
  }
  showPreloader(flag) {
    if (flag) {
      jQuery(".js-preloader").show();
    } else {
      jQuery(".js-preloader").hide();
    }
  }

  static showPreloader(flag) {
    if (flag) {
      jQuery(".js-preloader").show();
    } else {
      jQuery(".js-preloader").hide();
    }
  }

  track() {
    if (Globals.SHOW_TRACKING_DATA) {
      console.log("---tracking---");
      console.log("Event: " + PageCommon._normalizza_track_prop(o.event));
      console.log("Category: " + PageCommon._normalizza_track_prop(o.category));
      console.log("Label: " + o.label ? PageCommon._normalizza_track_prop(o.label) : "n/a");
    }

    let additional = {
      event_category: PageCommon._normalizza_track_prop(o.category)
    }
    if (o.label) {
      additional.event_label = PageCommon._normalizza_track_prop(o.label);
    }

    gtag('event', PageCommon._normalizza_track_prop(o.event), additional);

  }

  _normalizza_track_prop(s) {
    let ret = s.toLowerCase();
    ret = Pqp.safeReplace(ret, " ", "_");
    ret = Pqp.safeReplace(ret, "'", "_");
    ret = Pqp.safeReplace(ret, ".", "");
    ret = Pqp.safeReplace(ret, ",", "");
    ret = Pqp.safeReplace(ret, "(", "_");
    ret = Pqp.safeReplace(ret, ")", "");
    ret = Pqp.safeReplace(ret, "__", "_");
    return ret;
  }

  static disable(mc, lFlag, opacity = 1) {
    if (lFlag) {
      mc.css("pointer-events", "none");
      mc.css("opacity", opacity);
    } else {
      mc.css("pointer-events", "all");
      mc.css("opacity", 1);
    }

  }
}

